import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { API } from '../../API';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import { Box, Button, ListItemIcon } from '@mui/material';
import './notification.css'
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import EditIcon from '@mui/icons-material/Edit';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import AddLocationIcon from '@mui/icons-material/AddLocation';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import SecurityIcon from '@mui/icons-material/Security';
import UpcomingIcon from '@mui/icons-material/Upcoming';
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  iconStyle: {
    marginRight: "10px",
    color: "#0f7adf"
  }
});

export default function ListActivities({ activities, setActivities, handleRedirect, setUnreadActivitiesNumber, role }) {
  const styles = useStyles();

  const handleReadNoti = (activity) => {
    if (activity.is_read) {
      handleRedirect(activity)
      return
    }

    API.readNotification(activity._id)
      .then((res) => {
        const newActivities = activities.map(
          item => item._id === activity._id ? { ...item, is_read: true } : item
        )
        setActivities(newActivities)
        setUnreadActivitiesNumber((prevData) => prevData - 1)
        handleRedirect(activity)
      })
      .catch((error) => {
        console.log(`error`, error);
      })
  }

  const handleReadAllActivities = async () => {
    const unreadActivities = activities.filter((activity) => !activity.is_read)
    if (unreadActivities.length === 0) return

    const ids = unreadActivities.map((activity) => activity._id)
    API.readAllNotification({
      notificationIDs: ids
    }).then((rs) => {
      const newActivities = activities.map(activity => {
        activity.is_read = true;
        return activity;
      });
      setActivities(newActivities)
      setUnreadActivitiesNumber(0)
    }).catch((error) => {
      console.log(`error - read all notifications: `, error);
    });
  }

  const getIconForActivity = (notiType) => {
    let icon = <></>
    switch (notiType) {
      case "SEND LESSION MATERIAL":
        icon = <CloudDoneIcon className={styles.iconStyle}/>
        break;
      case "ADD MULTIPLE DAY BOOKING":
        icon = <EventAvailableIcon className={styles.iconStyle}/>
        break;
      case "UPDATE CLASS":
        icon = <EditIcon className={styles.iconStyle}/>
        break;
      case "DELETE PERSONNEL":
        icon = <PersonRemoveIcon className={styles.iconStyle}/>
        break;
      case "CREATE LISTING":
        icon = <AnnouncementIcon className={styles.iconStyle}/>
        break;
      case "ADD CAMPUS":
        icon = <AddLocationIcon className={styles.iconStyle}/>
        break;
      case "UPDATE CAMPUS":
        icon = <EditLocationIcon className={styles.iconStyle}/>
        break;
      case "CUSTOMER ADD PERSONNEL":
        icon = <PersonAddIcon className={styles.iconStyle}/>
        break;
      case "CUSTOMER UPDATE PERSONNEL":
        icon = <PersonIcon className={styles.iconStyle}/>
        break;
      case "CHANGE PASSWORD":
        icon = <VpnKeyIcon className={styles.iconStyle}/>
        break;
      case "CHANGE SECRET QUESTION":
        icon = <SecurityIcon className={styles.iconStyle}/>
        break;
      default:
        icon = <UpcomingIcon className={styles.iconStyle}/>
        break;
    }

    return icon
  }

  return (
    <>
      <List className='list-noti' sx={{ bgcolor: '#FAF6F6', overflowY: "scroll", paddingTop: "0px" }}>
        { 
          activities.length === 0 
          && <Typography variant="h6" className="ml-3 title">You don't have any activities</Typography>
        }
        {
          activities.map((activity, index) => (
            <React.Fragment key={index}>
              <ListItem
                alignItems="center"
                sx={{
                  "&:hover": { backgroundColor: '#F2F3F5', cursor: "pointer" }
                }}
                onClick={() => handleReadNoti(activity)}
                className="list-item"
              >
                {
                  role === "teacher" && (
                    <ListItemAvatar className="list-item-avatar">
                      <Avatar src={activity.photo  || "/static/images/avatar/2.jpg"} className="noti-avatar"/>
                    </ListItemAvatar>
                  )
                }
                {
                  (role === "customer" || role ==="personnel") && getIconForActivity(activity.type) && (
                    <ListItemIcon className="list-item-icon noti-icon">
                      {getIconForActivity(activity.type)}
                    </ListItemIcon>
                  )
                }
                <ListItemText
                  sx={{fontSize: "14px"}}
                  secondary={
                    <React.Fragment>
                      <Typography sx={{ fontSize: "14px" }} className={"noti-content " + (!activity.is_read && "unread")}>
                        {activity?.content || ""}
                      </Typography>
                    </React.Fragment>
                  }
                />
                {
                  !activity.is_read &&(
                    <ListItemIcon className="list-item-icon">
                      <Brightness1Icon fontSize='small' className="circle-icon"/>
                    </ListItemIcon>
                  )
                }
              </ListItem>
              {index < activities.length - 1 && <Divider className="divider-item ml-0" variant="inset" component="li" />}
            </React.Fragment>
          ))
        }
      </List>
      {
        activities.filter(activity => !activity.is_read).length > 0 && (
          <Box>
            <Button
              variant="contained"
              sx={{
                borderRadius: 0,
              }}
              className="w-100 read-all-btn"
              onClick={handleReadAllActivities}
            >
              Mark all as read
            </Button>
        </Box>
        )
      }
    </>
  );
}
